<template>
  <el-dialog :title="title" :visible.sync="visible" width="70%" :close-on-click-modal="false">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="文章标题:" prop="title">
        <el-input type="text"  :maxlength="30" v-model="data.title" placeholder="请输入30字以内文章标题" clearable />
      </el-form-item>
      <el-form-item label="类型:" prop="contentType">
        <el-select v-model="data.contentType" placeholder="请选择类型" clearable style="width:100%" :disabled="disabled">
          <el-option v-for="dict in typeList" :key="dict.id" :label="dict.name" :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item v-if="data.contentType === 1" label="列表排版:" prop="listStyle">
        <el-radio-group v-model="data.listStyle" @change="listStyleChange">
          <el-radio v-for="item in listStyleList" :key="item.value" :label="item.value">{{item.name}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="封面图:" prop="headPicUrlList">
        <span class="tips-text">请上传文章封面图片</span>
        <FileUploadHeader v-if="visible" v-model="fileObjsPic" :limit="picLimit" :readOnly="false" @on-change="handleFileChange($event, 'pic')"
                          accept="image/gif,image/jpg,image/jpeg,image/png" :fixedNumber="fixedNumber" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropWidth"></FileUploadHeader>
      </el-form-item>
      <el-form-item label="视频文件:" prop="videoUrl" v-if="data.contentType === 2" class="video-form-item">
        <span class="tips-text">请上传100M以内的视频文件</span>
        <FileUpload  v-if="visible" v-model="fileObjsVideo" :limit="1" :readOnly="false" @on-change="handleFileChange($event, 'video')" accept=".mp4,.mov,.avi,.flv"></FileUpload>
      </el-form-item>
      <el-form-item label="排序:" prop="tenantSortNo">
        <el-input-number v-model="data.tenantSortNo" style="width: 100px" :min="0" :max="2147483647" :controls="false"></el-input-number>
        <span style="margin-left: 10px; color: #aba9a9;">注：数值小的排在前面</span>
      </el-form-item>
      <el-form-item label="标签:" prop="tags">
        <el-checkbox-group v-model="data.tagList" @change="tagChange">
          <el-checkbox v-for="dict in tagList" :key="dict.dictValue" :label="dict.dictLabel" :disabled="dict.disabled"/>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="文章详情:" class="uEditor" prop="content" v-if="data.contentType === 1">
        <UEditor v-model="data.content"></UEditor>
      </el-form-item>
      <el-form-item label="简介:" prop="introduction" v-if="data.contentType === 2">
        <el-input type="textarea"  :maxlength="200" v-model="data.introduction" placeholder="请输入" clearable />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { saveArticle } from "@/api/saas/package";
import FileUpload from "@/views/crm/components/fileUpload";
import FileUploadHeader from "@/components/CropperFileUpload/CropperFileUpload";
import UEditor from '@/components/UEditor'

export default {
  name: "AddClueDialog",
  components: {
    FileUpload,
    FileUploadHeader,
    UEditor
  },
  props: {
  },
  data() {
    return {
      title: '',
      introduction: null,
      visible: false,
      typeList: [{
          id: 1,
          name: '图文'
      },{
          id: 2,
          name: '视频'
      }],
      rules: {
        title: [
          {required: true, message: '请输入文章标题', trigger: 'change'}
        ],
        contentType: [
          {required: true, message: '请选择文章类型', trigger: 'change'}
        ],
        listStyle: [
          {required: true, message: '请选择列表排版', trigger: 'change'}
        ],
        headPicUrlList: [
          {required: true, message: '请上传封面图', trigger: 'change'}
        ],
        videoUrl: [
          {required: true, message: '请上传文章视频', trigger: 'change'}
        ],
        content: [
          {required: true, message: '文章详情不可为空', trigger: 'change'}
        ],
        introduction: [
          {required: true, message: '简介不可为空', trigger: 'change'}
        ],
      },
      fileObjsPic: [],
      fileObjsVideo: [],
      data: {
        title: null,
        content: null,
        contentType: 1,
        listStyle: 1,
        introduction: null,
        headPicUrlList: null,
        videoUrl: null,
        articleType: 1,
        tenantSortNo: undefined,
        tagList: []
      },
      disabled: false,
      listStyleList: [
        {value: 1, name: '左标题右图'},
        {value: 2, name: '上标题下1图'},
        {value: 3, name: '上标题下3图'},
        {value: 4, name: '仅标题'}
      ],
      tagList: [],
      picLimit: 1,
      fixedNumber: [3, 2],
      autoCropWidth: 340,
      autoCropHeight: 272,
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible (val, val2) {
      if (!val) {
        // 重置formData
        this.resetFormData()
      }
    }
  },
  created() {
    this.getDicts("article_tag").then(response => {
      if (response.data) {
        response.data.forEach(item => {
          item.disabled = false
        })
        this.tagList = response.data;
      }
    });
  },
  methods: {
    resetFormData () {
      this.fileObjsPic= []
      this.fileObjsVideo= []
      this.resetForm("addForm");
      this.data.articleId = null
      this.data.title = null
      this.data.content = null
      this.data.contentType = 1
      this.data.introduction = null
      this.data.headPicUrlList = []
      this.data.videoUrl = null
      this.data.tenantSortNo = undefined
    },
    open (row) {
      this.visible = true
      this.resetFormData()
      if(row) {
        this.data = row
        this.listStyleChange(this.data.listStyle)
        this.tagChange(this.data.tagList)
        this.title = '编辑文章'
        this.disabled = true
        this.fileObjsPic = []
        row.headPicUrlList.forEach(item => {
          this.fileObjsPic.push({
            isImg: true,
            url: item
          })
        })
        this.fileObjsVideo = [{
          isImg: false,
          name: '视频',
          url: row.videoUrl
        }]
      } else {
        this.data.listStyle = 1
        this.data.tagList = []
        this.tagChange(this.data.tagList)
        this.listStyleChange(this.data.listStyle)
        this.disabled = false
        this.title = '添加文章'
      }
    },
    handleFileChange (fileObjs, type) {
      console.log('file', fileObjs)
      if(type === 'pic'){
        if (fileObjs.length == 0) {
          this.fileObjsPic = []
          this.data.headPicUrlList = []
        } else {
          this.fileObjsPic = fileObjs
          this.data.headPicUrlList = []
          fileObjs.forEach(item => {
            this.data.headPicUrlList.push(item.url)
          })
        }
      }else {
        if(fileObjs.length == 0){
          this.fileObjsVideo = []
          this.data.videoUrl = ''
        }else {
          this.fileObjsVideo = fileObjs
          this.data.videoUrl = fileObjs[0].url
        }
      }
    },
    tagChange (data) {
      if (data && data.length >= 3) {
        this.tagList.forEach(item => {
          if (data.indexOf(item.dictValue) < 0) {
            item.disabled = true
          } else {
            item.disabled = false
          }
        })
      } else {
        this.tagList.forEach(item => {
          item.disabled = false
        })
      }
    },
    listStyleChange (data) {
      // 列表排版 1-左标题右图 2-上标题下1图 3-上标题下3图 4-仅标题
      if (data === 1) {
        this.picLimit = 1
        this.fixedNumber = [3, 2]
        this.autoCropWidth = 340
        this.autoCropHeight = 227
      } else if (data === 2) {
        this.picLimit = 1
        this.fixedNumber = [16, 9]
        this.autoCropWidth = 355
        this.autoCropHeight = 200
      } else if (data === 3 || data === 4) {
        this.picLimit = 3
        this.fixedNumber = [5, 4]
        this.autoCropWidth = 340
        this.autoCropHeight = 272
      }
      if (data === 4) {
        // 仅标题，封面图非必传
        this.rules.headPicUrlList[0].required = false
      } else {
        this.rules.headPicUrlList[0].required = true
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (this.data.listStyle !== 4 && this.data.headPicUrlList.length <= 0) {
            this.msgError("封面图不能为空");
            return
          }
          if (this.data.contentType === 2) {
            this.data.listStyle = 2
          }
          // 列表排版 1-左标题右图 2-上标题下1图 3-上标题下3图 4-仅标题
          if ((this.data.listStyle === 1 || this.data.listStyle === 2) && this.data.headPicUrlList.length !== 1) {
            this.msgError("封面图只能为1张");
            return
          } else if ((this.data.listStyle === 3 || this.data.listStyle === 4) && this.data.headPicUrlList.length > 3) {
            this.msgError("封面图最多3张");
            return
          }
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          saveArticle(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            if(this.data.articleId){
              this.msgSuccess("编辑成功");
            }else {
              this.msgSuccess("添加成功");
            }
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.video-form-item{
  ::v-deep.ql-toolbar{
    display: none;
  }
}
</style>
